import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import {canNavigate} from '@/libs/acl/routeProtection'
import {isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser} from '@/auth/utils'
import base from './routes/base'
import auth from './routes/auth'
import references from './routes/references'
import exploitation from './routes/exploitation'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        ...auth,
        ...base
    ],
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.needsAuth)) {
        if (store.state.user.userData.email) {
            let hasAccess = false;

            const userRole = store.getters['user/role'];

            if (userRole === 'admin') hasAccess = true;

            const isAccessibleFor = to.matched[0]?.meta?.isAccessibleFor;

            if (isAccessibleFor && isAccessibleFor.indexOf(userRole) !== -1) {
                hasAccess = true;
            }
            if (isAccessibleFor === '*') {
                hasAccess = true;
            }

            if (hasAccess) {
                next();
            } else {
                // Redirect to appropriate home page based on role
                const homeRoutes = {
                    'admin': '/',
                    'student': '/',
                    'teacher': '/schedule/webinar',
                    'parent': '/parental-control/dashboard'
                };
                const homePath = homeRoutes[userRole] || '/';

                // Prevent infinite loop - don't redirect to the same path
                if (to.path !== homePath) {
                    next({
                        path: homePath,
                    });
                } else {
                    // If already at home path but no access, something is wrong
                    next({
                        path: '/login',
                    });
                }
            }
        } else {
            next({
                path: '/login',
            });
        }
    } else {
        next();
    }
});

export default router
